import { useEffect, useState, useMemo } from 'react'
import img from  './WhatsApp Image 2025-05-30 at 20.40.23_fc3211de.jpg'
import profil from './profil.css'
import { Social } from '../social-media/social-media';
function Profil () {
    const name = 'ROGER ALFANI ' 
    const nickname = 'WIN ALFANI '
    //here's the text effect 
const [displayText, setDisplayText] = useState('');
const [currentIndex,setCurrentIndex] = useState(0);
const [isDelecting, setIsDelecting] = useState(false);
const [loopNum, setLoopNum] = useState(0);

// skills and parameters
const skills = useMemo(() => [' an informatician',  'a software developer', 'a designer', 'a programmer'], []) 
const typeSpeed = 150
const deletingSpeed = 100
const pauseBetween = 2000
    useEffect ( () => { 
    const handleTyping = () => {
        
        const currentWord = skills[loopNum % skills.length]
        if (isDelecting){
            //To delete
            setDisplayText(currentWord.substring(0,displayText.length - 1));
            setCurrentIndex(currentIndex - 1);
        }
        else {
            //To write 
            setDisplayText(currentWord.substring(0, displayText.length + 1));
            setCurrentIndex(currentIndex + 1)

        }
        if (!isDelecting && displayText === currentWord){
            setTimeout(() => setIsDelecting(true),pauseBetween)
        }else if (isDelecting && displayText === '') {
            setIsDelecting(false);
            setLoopNum(loopNum + 1)
        }
    };
    const timer = setTimeout(
        handleTyping,
        isDelecting ? deletingSpeed : typeSpeed
    );
    return () => clearTimeout(timer);
}, [displayText, isDelecting,loopNum,currentIndex,skills])
    return (
        <div className="typewriter-container" id='div' style={profil}>
           
           <p  style={profil} className='Infos'>
             <img src={img} alt="profil" />
           <span>
             <h3>  {name}  <br /> <small>
                {nickname} </small> </h3>
         
        <Social />
      
         <a href="/#form"  className='a-profil'> Take an apointment </a>
      
       
           </span>
           </p>
      <h1>
        I am <span className="animated-text">{displayText}</span>
        <span className="cursor">|</span>
      </h1>

     
    </div>
    )
}
export default Profil 